<template>
  <div>
    <a-modal :title="title" :visible="visible" :maskClosable="false" :confirmLoading="confirmLoading" @ok="handleOk"
      @cancel="handleCancel" width="600px">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          {{ dataForm.status == 1 ? '关闭' : '取消' }}
        </a-button>
        <a-button v-if="dataForm.status != 1" key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
          确定
        </a-button>
      </template>
      <a-form-model ref="ruleForm" :model="dataForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="所属片区" prop="zoneId">
          <a-tree-select v-model="dataForm.zoneId" style="width: 100%" :tree-data="zoneTreeData"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择所属片区" allow-clear
            treeDefaultExpandAll @select="onZoneSelect" :disabled="isProcess" />
        </a-form-model-item>
        <a-form-model-item label="事件类型" prop="eventType">
          <a-select v-model="dataForm.eventType" placeholder="请选择事件类型" :disabled="isProcess">
            <a-select-option v-for="(label, value) in eventTypeMap" :key="value" :value="parseInt(value)">
              {{ label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="事件描述" prop="eventDescription">
          <a-input v-model="dataForm.eventDescription" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }"
            placeholder="请输入事件描述" :disabled="isProcess" />
        </a-form-model-item>
        <a-form-model-item v-if="isProcess && eventImagesList.length > 0" label="事件图片" prop="imageUrls">
          <div>
            <div v-for="(item, index) in eventImagesList" :key="index"
              style="display: inline-block; margin-right: 8px; margin-bottom: 8px; position: relative;">
              <img :src="item.url" alt=""
                style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                @click="previewImage(item.url)" />
            </div>
          </div>
        </a-form-model-item>

        <!-- 非处理模式下显示的字段 -->
        <template v-if="!isProcess">
          <a-form-model-item label="事件地址" prop="address">
            <a-input v-model="dataForm.address" placeholder="请输入事件地址" />
          </a-form-model-item>
          <a-form-model-item label="事件日期" prop="eventDate">
            <a-date-picker v-model="dataForm.eventDate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" style="width: 100%"
              placeholder="选择日期" :disabled-date="disabledDate" />
          </a-form-model-item>
          <a-form-model-item v-if="!isProcess || eventImagesList.length > 0" label="事件图片" prop="imageUrls">
            <a-upload v-if="!isProcess" name="file" :multiple="true"
              :customRequest="(data) => customRequest(data, 'event')" :showUploadList="false"
              :beforeUpload="beforeUpload" accept="image/*">
              <a-button>
                <a-icon type="upload" /> 上传图片
              </a-button>
            </a-upload>
            <div v-if="eventImagesList.length > 0" style="margin-top: 16px">
              <div v-for="(item, index) in eventImagesList" :key="index"
                style="display: inline-block; margin-right: 8px; margin-bottom: 8px; position: relative;">
                <img :src="item.url" alt=""
                  style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                  @click="previewImage(item.url)" />
                <a-icon v-if="!isProcess" type="close-circle"
                  style="position: absolute; top: -8px; right: -8px; font-size: 18px; color: #ff4d4f; cursor: pointer; background: white; border-radius: 50%;"
                  @click="deleteImage(index, 'event')" />
              </div>
            </div>
          </a-form-model-item>
        </template>

        <!-- 处理模式下显示的字段 -->
        <template v-if="isProcess">
          <a-form-model-item label="处理描述" prop="processDescription">
            <a-input v-model="dataForm.processDescription" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }"
              placeholder="请输入处理描述" :disabled="dataForm.status == 1" />
          </a-form-model-item>
          <a-form-model-item label="处理人" prop="conductor">
            <a-input v-model="dataForm.conductor" placeholder="请输入处理人" :disabled="dataForm.status == 1" />
          </a-form-model-item>
          <a-form-model-item v-if="dataForm.status != 1 || fileNamesimg.length > 0" label="处理图片"
            prop="processImageUrls">
            <a-upload v-if="isProcess && dataForm.status != 1" name="file" :multiple="true"
              :customRequest="customRequest" :showUploadList="false" :beforeUpload="beforeUpload" accept="image/*">
              <a-button>
                <a-icon type="upload" /> 上传图片
              </a-button>
            </a-upload>
            <div v-if="fileNamesimg.length > 0" style="margin-top: 16px">
              <div v-for="(item, index) in fileNamesimg" :key="index"
                style="display: inline-block; margin-right: 8px; margin-bottom: 8px; position: relative;">
                <img :src="item.url" alt=""
                  style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                  @click="previewImage(item.url)" />
                <a-icon v-if="dataForm.status != 1" type="close-circle"
                  style="position: absolute; top: -8px; right: -8px; font-size: 18px; color: #ff4d4f; cursor: pointer; background: white; border-radius: 50%;"
                  @click="deleteImage(index)" />
              </div>
            </div>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handlePreviewCancel" width="800px">
      <img alt="预览图片" style="width: 100%" :src="previewImageUrl" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { resolveFileUrl } from '@/utils/imageUtils'

const eventTypeMap = {
  1: '维修',
  2: '巡线',
  3: '二次供水',
  4: '用户检漏',
  5: '自检查漏',
  6: '农污',
  7: '其它'
}

export default {
  name: 'MaintainAddOrUpdate',
  data () {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      queryOneUrl: '/zone-metering/maintenance-records',
      addOrUpdateUrl: '/zone-metering/maintenance-records/save',
      uploadUrl: '/zone-metering/maintenance-records/upload-image',
      dataForm: {
        id: 0,
        zoneId: undefined,
        zoneName: '',
        eventType: undefined,
        eventDescription: '',
        address: '',
        eventDate: null,
        imageUrls: [], // 事件图片
        processDescription: '',
        conductor: '',
        processImageUrls: [], // 处理图片
        status: 0
      },
      eventTypeMap,
      zoneTreeData: [],
      isProcess: false, // 是否为处理模式
      eventImagesList: [], // 事件图片列表
      fileNamesimg: [], // 处理图片列表
      previewVisible: false, // 预览显示
      previewImageUrl: '', // 预览图片地址
      rules: {
        zoneId: [{ required: true, message: '请选择所属片区', trigger: 'change' }],
        eventType: [{ required: true, message: '请选择事件类型', trigger: 'change' }],
        eventDate: [{ required: true, message: '请选择事件日期', trigger: 'change' }]
      }
    }
  },
  computed: {
    title () {
      if (this.isProcess) {
        return this.dataForm.status == 1 ? '查看详情' : '处理事件'
      }
      return !this.dataForm.id ? '添加事件' : '编辑事件'
    }
  },
  created () {
    this.getZoneData()
  },
  methods: {
    normalizeImageItem (img) {
      if (typeof img === 'string') {
        return { url: resolveFileUrl(img), name: '' }
      }
      return {
        ...img,
        url: resolveFileUrl(img.url)
      }
    },
    // type: 'edit' | 'process'
    init (record, type = 'edit') {
      this.visible = true
      this.isProcess = type === 'process'

      // 初始化默认值
      const defaultForm = {
        id: 0,
        zoneId: undefined,
        zoneName: '',
        eventType: undefined,
        eventDescription: '',
        address: '',
        eventDate: null,
        imageUrls: [],
        processDescription: '',
        conductor: '',
        processImageUrls: [],
        status: 0
      }

      this.previewVisible = false

      this.$nextTick(() => {
        // 1. 先重置表单，清空校验状态
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields()
        }

        // 2. 根据是否有 record 进行数据填充
        if (record && record.id) {
          // 编辑或处理模式：直接使用传入的 record 对象赋值
          this.dataForm = Object.assign({}, defaultForm, record)

          // 确保特定的字段正确映射（如果字段名一致其实 Object.assign 已经处理了）
          this.dataForm.eventType = record.eventType
          this.dataForm.zoneId = record.zoneId

          // 加载事件图片
          if (record.imageUrls && Array.isArray(record.imageUrls)) {
            this.eventImagesList = record.imageUrls.map(img => this.normalizeImageItem(img))
          } else {
            this.eventImagesList = []
          }
          // 加载处理图片
          if (record.processImageUrls && Array.isArray(record.processImageUrls)) {
            this.fileNamesimg = record.processImageUrls.map(img => this.normalizeImageItem(img))
          } else {
            this.fileNamesimg = []
          }
        } else {
          // 新增模式
          this.dataForm = { ...defaultForm }
          this.eventImagesList = []
          this.fileNamesimg = []
        }
      })
    },
    getZoneData () {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    onZoneSelect (value, node, extra) {
      this.dataForm.zoneName = node.dataRef.zoneName
    },
    handleOk () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          const params = {
            ...this.dataForm
          }

          // 新增时删除 id 字段
          if (!this.dataForm.id) {
            delete params.id
          }

          // 提交事件图片
          params.imageUrls = this.eventImagesList.map(item => item.url)

          // 处理模式下：设置状态为已处理(1)，并记录处理时间(当前时间)
          if (this.isProcess) {
            params.status = 1
            params.handleTime = moment().format('YYYY-MM-DD HH:mm:ss')
            // 提交处理图片
            params.processImageUrls = this.fileNamesimg.map(item => item.url)
          }

          const request = !this.dataForm.id
            ? this.$http.post(this.addOrUpdateUrl, params)
            : this.$http.put(this.addOrUpdateUrl, params)

          request.then(res => {
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('refreshDataList')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.eventImagesList = []
      this.fileNamesimg = []
      this.previewVisible = false
    },
    disabledDate (current) {
      // Can not select days after today
      return current && current > moment().endOf('day')
    },
    // 上传前校验
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB!')
      }
      return isImage && isLt10M
    },
    // 自定义上传
    customRequest (data, type = 'process') {
      const formData = new FormData()
      formData.append('file', data.file)
      this.$http.post(this.uploadUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        if (res.code === 0) {
          const fileUrl = resolveFileUrl(res.message)
          const imgObj = {
            url: fileUrl,
            name: fileUrl || ''
          }
          if (type === 'event') {
            this.eventImagesList.push(imgObj)
          } else {
            this.fileNamesimg.push(imgObj)
          }
          this.$message.success('上传成功')
        } else {
          this.$message.error(res?.message || '上传失败')
        }
      }).catch(() => {
        this.$message.error('上传出错')
      })
    },
    // 删除图片
    deleteImage (index, type = 'process') {
      if (type === 'event') {
        this.eventImagesList.splice(index, 1)
      } else {
        this.fileNamesimg.splice(index, 1)
      }
    },
    // 预览图片
    previewImage (url) {
      this.previewImageUrl = resolveFileUrl(url)
      this.previewVisible = true
    },
    // 关闭预览
    handlePreviewCancel () {
      this.previewVisible = false
    }
  }
}
</script>
